<template>
  <div class="base-card is-loading">
    <div class="row-1">
      <div class="tags">
        <SkeletonLoader
          width="40px"
          height="24px"
        />
        <SkeletonLoader
          width="40px"
          height="24px"
        />
      </div>
      <div class="likes-section">
        <button
          v-show="false"
          class="iconify-skeleton"
        >
          <Icon
            name="lucide:thumbs-up"
            size="16"
          />
        </button>
        <button
          v-show="false"
          class="iconify-skeleton"
        >
          <Icon
            name="lucide:thumbs-down"
            size="16"
          />
        </button>
      </div>
    </div>
    <div class="row-2">
      <div class="image-preview">
        <SkeletonLoader
          class="preview-skeleton"
          width="113px"
          height="auto"
        />
      </div>
      <div class="content-section">
        <div class="content-skeleton">
          <SkeletonLoader
            width="70%"
            height="20px"
          />
          <SkeletonLoader
            width="90%"
            height="16px"
          />
          <SkeletonLoader
            width="40%"
            height="16px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SkeletonLoader from '~/components/global/SkeletonLoader.vue';
</script>

<style lang="scss" scoped>
@use '../../global/scss/mixins/_breakpoints.scss' as bp;

.base-card {
  --color-grey-100: #e0e0e0;
  --color-gray-200: #d3d3d3;
  --color-grey-500: #949494;
  --color-grey-950: #2d2d2d;
  --color-blue-500: #1850c1;
  --color-text-primary: #2d2d2d;
  --color-text-secondary: #474747;
  --color-text-tertiary: var(--color-grey-500);
  --color-purple-500: #662e80;

  border-radius: 4px;
  border: 1px solid var(--color-grey-100);
  padding: 16px;
  text-decoration: none;
  gap: 32px;
  pointer-events: none;

  .row-1 {
    display: flex;
    justify-content: space-between;
  }

  .row-2 {
    display: flex;
  }

  .image-preview {
    display: flex;
    align-items: center;
    margin-right: 16px;
  }

  .content-section {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .likes-section {
    display: flex;
    gap: 12px;
    color: var(--color-grey-500);
    button {
      border-radius: 4px;
      background: none;
      border: none;
      cursor: none;
      pointer-events: none;
      color: inherit;
      width: 24px;
      height: 24px;
    }
  }

  .preview-skeleton {
    aspect-ratio: 4/3;
    @include bp.screen('<=sm') {
      width: 96px;
      height: 72px;
    }
  }

  .content-skeleton {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .tags {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
  }
}

@include bp.screen('<=sm') {
  .base-card {
    gap: 16px;
  }
}
</style>
